import { useEffect, useState } from "react";
import { api, fmtEUR } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { FileClock, CreditCard, CalendarDays, Euro, Users, CheckCircle2 } from "lucide-react";

const KPIS = [
  { key: "offene_auftraege", label: "Offene Aufträge", icon: FileClock, accent: "text-blue-600 bg-blue-50", testid: "kpi-offene-auftraege" },
  { key: "wartet_auf_zahlung", label: "Wartet auf Zahlung", icon: CreditCard, accent: "text-amber-700 bg-amber-50", testid: "kpi-wartet-auf-zahlung" },
  { key: "heute_erstellt", label: "Heute erstellt", icon: CalendarDays, accent: "text-slate-700 bg-slate-100", testid: "kpi-heute-erstellt" },
  { key: "umsatz_monat_brutto", label: "Umsatz Monat (brutto)", icon: Euro, accent: "text-emerald-700 bg-emerald-50", format: fmtEUR, testid: "kpi-umsatz-monat" },
  { key: "kunden_gesamt", label: "Kunden gesamt", icon: Users, accent: "text-indigo-700 bg-indigo-50", testid: "kpi-kunden-gesamt" },
  { key: "fertige_auftraege", label: "Fertige Aufträge", icon: CheckCircle2, accent: "text-emerald-700 bg-emerald-50", testid: "kpi-fertige-auftraege" },
];

export default function Dashboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/dashboard/kpis").then((r) => setData(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6" data-testid="dashboard-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">Dashboard</h1>
        <p className="text-sm text-slate-500 mt-1">Übersicht Ihrer aktuellen Aufträge und Umsätze.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {KPIS.map((k) => {
          const val = data ? (k.format ? k.format(data[k.key]) : data[k.key] ?? 0) : "—";
          return (
            <Card key={k.key} className="border-slate-200 hover:shadow-sm transition-shadow" data-testid={k.testid}>
              <CardContent className="p-5 flex items-start justify-between gap-4">
                <div>
                  <div className="font-mono text-xs font-medium text-slate-500 tracking-wider uppercase">{k.label}</div>
                  <div className="text-3xl font-bold tracking-tight text-slate-900 mt-2">{val}</div>
                </div>
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${k.accent}`}>
                  <k.icon className="w-5 h-5" />
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
